export const courseList = [
    {
        "id": 1,
        "name": "Ментальная арифметика",
        "shortName": "МА",
        "color": "#55cc78",
    },
    {
        "id": 2,
        "name": "Олимпиадная математика",
        "shortName": "ОМ",
        "color": "#8B8DF7",
    },
    {
        "id": 3,
        "name": "Подготовка к школе",
        "shortName": "ПкШ",
        "color": "#7D9184",
    },
    {
        "id": 4,
        "name": "Арт-студия",
        "shortName": "Арт",
        "color": "#93F772",
    },
    {
        "id": 5,
        "name": "Русский язык",
        "shortName": "РЯ",
        "color": "#8BC5F7",
    },
    {
        "id": 6,
        "name": "Секреты умножения",
        "shortName": "СУ",
        "color": "#F7AD8B",
    },
    {
        "id": 7,
        "name": "Скорочтение +",
        "shortName": "СЧ+",
        "color": "#F75F59",
    },
    {
        "id": 8,
        "name": "Скорочтение",
        "shortName": "СЧ",
        "color": "#C58BF7",
    },
    {
        "id": 9,
        "name": "Техника чтения",
        "shortName": "ТЧ",
        "color": "#AB8446",
    },
    {
        "id": 10,
        "name": "Суперпамять",
        "shortName": "СП",
        "color": "#F7BA59",
    },
    {
        "id": 11,
        "name": "Учись учиться",
        "shortName": "УУ",
        "color": "#72F7A1",
    }
]